import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '_atoms';
import { useScrollTop } from 'helpers/useScrollTop';
import { deletePicture } from 'redux/reducers/picturesReducer';
import backImg from 'styles/images/icons/back.png';
import { buildGallery } from '../books_in';
import { BooksInExemlarCover } from '../books_in_exemplar_cover';
import { putPicture } from '../../redux/actions/pictures';
import { LoaderSpinner } from '../loaderAndSpinners';
import { BooksInAddind } from '../books_in_adding';

const loaderInitial = { loader: 0, showLoader: false, showAnswer: '', showLineLoader: false };

export const ExtraPhotoMosaic = ({ onBack, addToBasket, numberOfCopies: copiesInitial = 1 }) => {
  const dispatch = useDispatch();
  useScrollTop();

  const [numberOfCopies, setNumberOfCopies] = useState(copiesInitial);
  const [loaderState, setLoaderState] = useState(loaderInitial);
  const { coverImages } = useSelector(state => state.pictures.uploadedPictures);

  const onChangeCopies = e => setNumberOfCopies(e.target.value);

  const onAddToBasket = () => {
    addToBasket({ comment: '', numberOfCopies }, {});
  };

  const addPhoto = async ({ target: { name, files } }) => {
    setLoaderState(s => ({ ...s, loader: 50, showLoader: true, showLineLoader: true }));
    await dispatch(putPicture(files[0], name));
    setLoaderState(loaderInitial);
  };
  const deletePhoto = (id, massName) => dispatch(deletePicture({ id, massName }));

  const massCoverPhoto = buildGallery({
    mass: coverImages,
    tagName: BooksInExemlarCover,
    count: 1,
    addPhoto,
    deletePhoto,
    saveCurrentPictOrder: () => {},
    changePictOrder: () => {},
  });

  return (
    <div id="books_in_page" className="books-in-page photobook-premium">
      <img className="go-back" src={backImg} alt="" role="none" onClick={onBack} />
      <p className="books-in-page-title">Выберите основную фотография для фотомазайки</p>
      <div className="postcards-extra__images">{massCoverPhoto}</div>
      <div className="divider" />
      <p className="books-in-page-title">Кол-во экземпляров</p>
      <BooksInAddind numberOfCopies={numberOfCopies} handleChange={onChangeCopies} />
      <Button className="blue" name="currentTab" onClick={onAddToBasket}>
        Добавить в корзину
      </Button>

      <LoaderSpinner
        showLoader={loaderState.showLoader}
        showAnswer={loaderState.showAnswer}
        closeLoader={() => setLoaderState(loaderInitial)}
        showLineLoader={loaderState.showLineLoader}
        loader={loaderState.loader}
      />
    </div>
  );
};
